<div class="main-layout">
    <div class="header-container">
         <app-quotation-top-header></app-quotation-top-header>
        <app-quotation-header (collapsedState)="onHeaderCollapse($event)"></app-quotation-header>
    </div>

    <div class="content-wrapper" [class.expanded]="!isHeaderCollapsed" [class.collapsed]="isHeaderCollapsed">
        <div class="card">
            <div class="header-cont">
                <h2 class="header-title">Customer Management</h2>
                <div class="action-buttons">
                    <button pButton type="button" label="New Customer" icon="pi pi-plus" (click)="openNew()"
                        class="p-mr-2"></button>
                </div>
            </div>
            <div class="card-body">
                <p-table [value]="customers" [rows]="10" [paginator]="true"
                    [globalFilterFields]="['customerDetails.customerName', 'contactPerson.contactPersonName', 'contactPerson.contactPersonEmail']"
                    [tableStyle]="{'min-width': '75rem'}" [loading]="loading" responsiveLayout="scroll"
                    [rowHover]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [showCurrentPageReport]="true" class="custom-table">

                    <ng-template pTemplate="caption">
                        <div class="flex align-items-center justify-content-between" style="border-radius: 15px;">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text" placeholder="Search..." />
                            </span>
                        </div>
                    </ng-template>

                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="customerDetails.customerName">Customer Name <p-sortIcon
                                    field="customerDetails.customerName"></p-sortIcon></th>
                            <th pSortableColumn="contactPerson.contactPersonName">Contact Person <p-sortIcon
                                    field="contactPerson.contactPersonName"></p-sortIcon></th>
                            <th pSortableColumn="contactPerson.contactPersonEmail">Email <p-sortIcon
                                    field="contactPerson.contactPersonEmail"></p-sortIcon></th>
                            <th>Default Shipping Address</th>
                            <th pSortableColumn="status">Status <p-sortIcon field="status"></p-sortIcon></th>
                            <th>Actions</th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-customer>
                        <tr>
                            <td>{{customer.customerDetails.customerName}}</td>
                            <td>{{customer.contactPerson.contactPersonName}}</td>
                            <td>{{customer.contactPerson.contactPersonEmail}}</td>
                            <td>{{getDefaultShippingAddress(customer)}}</td>
                            <td>
                                <p-tag [value]="customer.status"
                                    [severity]="getStatusSeverity(customer.status)"></p-tag>
                            </td>
                            <td>
                                <div class="flex">
                                    <button pButton pRipple icon="pi pi-pencil"
                                        class="p-button-rounded p-button-success mr-2"
                                        (click)="editCustomer(customer)"></button>
                                    <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger"
                                        (click)="deleteCustomer(customer)"></button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            In total there are {{customers ? customers.length : 0 }} customers.
                        </div>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="6">No customers found.</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>

        <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

        <app-create-customer-dialog #customerDialog (customerCreated)="onCustomerCreated($event)"
            (customerUpdated)="onCustomerUpdated($event)">
        </app-create-customer-dialog>
    </div>
    <!-- <app-quotation-footer></app-quotation-footer> -->